import { render } from "./manual2.vue?vue&type=template&id=1e963362&scoped=true"
import script from "./manual2.vue?vue&type=script&lang=js"
export * from "./manual2.vue?vue&type=script&lang=js"

import "./manual2.vue?vue&type=style&index=0&id=1e963362&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e963362"]])

export default __exports__